<div class="creation-modification-trajet">
	<app-formulaire-trajet [trajet]="trajetAModifier"
	                       (fermerFormulaireEvent)="onFermer()"
	                       (submitFormulaireEvent)="submitFormulaire($event)">
	</app-formulaire-trajet>
</div>
